import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import { pageMeta, faq, sections, steps } from '../content/monetaryClaimsContent';

const MonetaryClaimsLawyerPage = () => (
  <ServiceLandingPage
    {...pageMeta}
    faq={faq}
    sections={sections}
    steps={steps}
    midPageCta="contact"
  />
);

export default MonetaryClaimsLawyerPage;
